export default __webpack_public_path__ + "static/SectionTwo_01_03@2x-5add25a553f9cd79d7f04345e6425d28.webp";